<app-main-navbar></app-main-navbar>

<div class="page">
  <!-- Header -->
  <div class="header">
    <h3 class="eyebrow">COMPANY INSIGHTS</h3>
    <!-- <h1 class="page-title">Find any company</h1> -->
    <p class="subtitle">Find the company you are looking for by entering the legal company name, ISIN or website URL and select the company type.</p>
  </div>

  <!-- Search card -->
  <div class="card search-card">
    <form [formGroup]="companySearchForm">
      <div class="search-row">
        <div class="field">
          <label class="field-label" for="name">Company Name</label>
          <input type="text" class="form-control" data-cy="company-name" id="name"
            placeholder="e.g. Samsung Electronics" formControlName="name">
        </div>
        <span class="or-sep">or</span>
        <div class="field">
          <label class="field-label" for="isin">ISIN</label>
          <input type="text" class="form-control" data-cy="company-isin" id="isin"
            placeholder="e.g. US0378331005" formControlName="isin">
        </div>
        <span class="or-sep">or</span>
        <div class="field">
          <label class="field-label" for="url">Website URL</label>
          <input type="text" class="form-control" data-cy="company-url" id="url"
            placeholder="e.g. samsung.com" formControlName="url">
        </div>

        <div class="search-action">
          <div class="spinner-container" *ngIf="showSpinner">
            <div class="spinner-border text-primary spinner-border-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <button class="btn search-button" (click)="companySearch()"
            [disabled]="!companySearchForm.value.name && !companySearchForm.value.url && !companySearchForm.value.isin"
            data-cy="company-search-button">
            <i class="bi bi-search"></i> Search
          </button>
        </div>
      </div>

      <hr class="card-divider">

      <!-- Company type chips -->
      <div class="type-row">
        <span class="type-label">Company type</span>
        <button type="button" class="type-chip" [class.active]="companySearchForm.value.companytype === 'Public Company'"
          (click)="onSearchTypeChange('Public Company')">Public Company</button>
        <button type="button" class="type-chip" [class.active]="companySearchForm.value.companytype === 'Private Company'"
          (click)="onSearchTypeChange('Private Company')">Private Company</button>
        <button type="button" class="type-chip" [class.active]="companySearchForm.value.companytype === 'All'"
          (click)="onSearchTypeChange('All')" matTooltip="Includes all subsidiaries"
            matTooltipPosition="above">
          All
          <!-- <i class="bi bi-info-circle type-info" matTooltip="Includes all subsidiaries"
            matTooltipPosition="above"></i> -->
        </button>
      </div>
    </form>
  </div>

  <!-- Recent searches -->
  <div class="recent-searches" *ngIf="recentSearches.length > 0">
    <p class="recent-label" (click)="toggleRecent()">
      RECENT SEARCHES
      <span class="toggle-arrow">{{ showRecent ? '&#9650;' : '&#9660;' }}</span>
    </p>
    <div class="recent-chips" *ngIf="showRecent">
      <div class="recent-chip" *ngFor="let entry of recentSearches">
        <i class="bi bi-clock clock-icon"></i>
        <span class="recent-text" (click)="applyRecentSearch(entry)">{{ entry.value }}</span>
        <span class="close-icon" (click)="removeRecent(entry)">&#10005;</span>
      </div>
    </div>
  </div>

  <!-- Search results -->
  <div class="card results-card" *ngIf="companies.length > 0">
    <table class="table table-condensed table-hover">
      <thead>
        <tr>
          <th scope="col">Name</th>
          <th scope="col">Country</th>
          <th scope="col">Region</th>
          <th scope="col">GICS Sub-Industry<i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
              [matTooltip]="'Quant IP classifies private companies into the closest GICS industry via patent similarity; public companies keep their GICS Sub-industry.'"
              matTooltipPosition="above">
            </i> </th>
          <th scope="col">Inventions (all time)</th>
          <th scope="col">Identifiers</th>
          <th scope="col">Action</th>
          <th scope="col" *ngIf="roles!.includes('Report') ">Report (V1)
            <div class="spinner-border text-primary" role="status" *ngIf="reportDownloadingV1">
              <span class="visually-hidden">Loading...</span>
            </div>
          </th>
          <th scope="col" *ngIf="roles!.includes('ReportV2') ">Report (V2)
            <div class="spinner-border text-primary" role="status" *ngIf="reportDownloadingV2">
              <span class="visually-hidden">Loading...</span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let company of companies  | paginate: {id:'pag_company_search', itemsPerPage: 10, currentPage: paginator_1_page }">

          <td>
            <div class="text" style="max-width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            " matTooltip="{{company.entity_name}}">
              {{ company.entity_name }}
            </div>
            <div class="isin">
              {{company.isin}} <a
                [href]="company.webpage && company.webpage.startsWith('http') ? company.webpage : (company.webpage ? 'http://' + company.webpage : '#')"
                target="_blank">
                <i class="bi bi-box-arrow-up-right" style="font-size: 14px;"></i>
              </a>
            </div>
          </td>

          <td>{{company.country}}</td>
          <td>{{company.region}}</td>
          <td>
            <span *ngIf="company.gsubind_extended_name">{{company.gsubind_extended_name}}</span>
            <span *ngIf="!company.gsubind_extended_name && company.subindustryname">{{company.subindustryname}}</span>
          </td>

          <td>{{company.n_inventions}}</td>

          <td>
            QIP <i class="bi bi-copy" style="margin-right: 20px;color:#1E3A8A" matTooltip="Copy Quant IP Entity ID"
              [cdkCopyToClipboard]="company.entityid"></i> S&P
            <i class="bi bi-copy" style="margin-right: 20px;color:black" matTooltip="Copy Capital IQ Company ID"
              [cdkCopyToClipboard]="company.companyid?.toString() || ''"></i>
          </td>

          <td>
            <button class="btn search-button" (click)="addCompany(company)"
              [disabled]="!company.gsubind_extended && !company.gsubind" data-cy="select-company-button">
              View
            </button>
          </td>
          <td *ngIf="roles!.includes('Report') ">
            <button class="btn download-button" (click)="downloadreportv1(company)"
              [disabled]="reportDownloadingV2||reportDownloadingV1" data-cy="report-v1-button">
              <i class="bi bi-file-earmark-arrow-down"></i> </button>
          </td>
          <td *ngIf="roles!.includes('ReportV2') ">
            <button class="btn download-button" (click)="downloadreportv2(company)"
              [disabled]="!company.subindustryname||reportDownloadingV2||reportDownloadingV1"
              data-cy="report-v2-button">
              <i class="bi bi-file-earmark-arrow-down"></i> </button>
          </td>
        </tr>
      </tbody>
    </table>
    <pagination-controls id="pag_company_search" [maxSize]="5" (pageChange)="paginator_1_page = $event"
      style="align-items: flex-start;">
    </pagination-controls>
  </div>
</div>
